import { update } from "framework/http/endpoint";
import { createEntityRequest } from "framework/http/rest/jsonRequest";
import { UrlPathOfApiLocation } from "common/paths";
var EventsApiUri = "".concat(UrlPathOfApiLocation, "/api/1/accounts/current/consent");
export function apiUpdateCurrentAccountCookieConsent(data) {
    var uri = EventsApiUri;
    var request = createEntityRequest(data);
    return update(uri, request);
}
